export const UPDATE_PHASE = {
    APPLIED: 'APPLIED',
    READY_FOR_QA_REVIEW: 'READY_FOR_QA_REVIEW',
    READY_FOR_PEER_REVIEW: 'READY_FOR_PEER_REVIEW',
    DRAFT: 'DRAFT',
} as const;

export const SORT_BY = {
    CREATED_ON: 'CREATED_ON',
    UPDATED_ON: 'UPDATED_ON',
} as const;

export const SORT_ORDER = {
    ASC: 'ASC',
    DESC: 'DESC',
} as const;
